module.exports = __webpack_public_path__ + "48ba5803ea5a0a165b8b343e50a12b8a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/bloomberg_2022_chart.png
// module id = 1636
// module chunks = 0